import { apiFetch } from "./apiClient";

/** Cambia únicamente la deuda de la persona; el reintegro a AF es independiente. */
export function cambiarEstadoAsignacionLavanderia(id: number, revision: string, estadoPago: "pendiente" | "pagado") {
  return apiFetch(`/finanzas/lavanderia-asignaciones/${id}/estado`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ revision, estadoPago }),
    errorMsg: "No se pudo actualizar el pago de lavandería; vuelve a cargar el movimiento.",
  });
}
